import { useIsCompactView } from "../../../core_stores/useIsCompactViewStore";

export function WelcomeDescription() {
  const isCompactView = useIsCompactView();

  return (
    <div className={`${isCompactView && "px-4"} flex flex-col items-center gap-6 z-20 w-full`}>
      <h1
        className={`${
          isCompactView ? "text-[clamp(2rem,10vw,3rem)]" : "text-[56px]"
        } font-bold text-center leading-[1.1] text-dark-text`}
      >
        Apps That Feel Premium
      </h1>
      <p
        className={`${
          isCompactView ? "text-[clamp(1rem,4.5vw,1.25rem)]" : "text-[24px]"
        } text-dark-text-secondary text-center leading-relaxed font-normal max-w-[800px] mx-auto group`}
      >
        {isCompactView ? (
          <>
            <span className="whitespace-nowrap">AI-powered <span className="relative inline-block">
              <span className="relative z-10">Flutter apps</span>
              <span className="absolute bottom-0 left-0 right-0 h-[2px] bg-gradient-to-r from-[#E91E63] to-[#9C27B0] opacity-40 group-hover:opacity-70 transition-opacity duration-300" />
            </span>.</span>
            <br />
            <span className="whitespace-nowrap">Just describe what you need.</span>
          </>
        ) : (
          <>
            AI-powered <span className="relative inline-block">
              <span className="relative z-10">Flutter apps</span>
              <span className="absolute bottom-0 left-0 right-0 h-[2px] bg-gradient-to-r from-[#E91E63] to-[#9C27B0] opacity-40 group-hover:opacity-70 transition-opacity duration-300" />
            </span> with pixel-perfect UI.
            <br />
            Just describe what you need.
          </>
        )}
      </p>
    </div>
  );
}
